<template>
  <div
    class="self-option"
    ref="optionDomRef"
    :class="getOptionClass(item)"
    :title="item.missingFont ? '缺失字体' : ''"
    :key="`${item.id}_${item.name}_${item.key}`"
    @mouseover.stop="onMousehover(item)"
    @mouseout.stop="onMouseout(item)"
    @click="onItemClick(item, $event)"
  >
    <div
      v-if="item.isPageBgImg && item.backgroundColor"
      :style="getPageBgStyle(item)"
    ></div>
    <el-popover
      v-else-if="item.type === 'img' && !item.htmlViewImg"
      :disabled="disabledEditorOperation(item)"
      placement="top"
      title=""
      width="200"
      trigger="hover"
      :visible-arrow="false"
      popper-class="editor-area-popover"
    >
      <div class="img-edit-header">
        <span
          class="ea-icon"
          v-if="!isGroupMaterial(item)"
          @click="showImgEditor(item)"
        >
          <i class="icon1-font icon1-cut"></i>裁剪
        </span>
        <span
          class="ea-icon"
          v-if="item.isGroupMaterial && hasGroupMaterial"
          @click="onOpenGroupDialog(item)"
        >
          <i class="icon1-font icon1-jigsaw"></i>拼图
        </span>
      </div>
      <div
        slot="reference"
        class="img-parent-box"
        @click.stop="onImgClick($event, item)"
        :style="{ height: `${item.height}px` }"
      >
        <img
          v-if="showImg(item) && !isGroupMaterial(item)"
          class="option-img"
          :src="item.url"
          :key="item.key"
          :style="getStyle(item)"
        />
        <img-template
          v-if="showImg(item) && isGroupMaterial(item)"
          @click.stop.native="onImgClick($event, item)"
          class="material-group-img"
          :size="{ width: item.width, height: item.height }"
          :data="item.materialGroup"
        >
        </img-template>
        <div
          v-if="showImg(item) && item.coverObj"
          :style="calcImgCoverStyle(item)"
        ></div>
      </div>
    </el-popover>
    <img
      class="self-option-word"
      v-else-if="item.isEditableTable && item.htmlViewImg"
      :src="item.htmlViewImg"
      :style="{ borderRadius: `${item.borderRadius || 0}px` }"
    />
    <div
      v-if="edit && item.isEditableTable && item.htmlViewImg"
      class="table-tip text-hover-tip module-group-tip"
      :style="tableTipStyle"
      @click="onTableClick(item)"
    >
      点击此处编辑表格内容
    </div>
    <div
      class="option-text"
      :key="`${item.id}_${item.name}_${item.key}`"
      @drop="notAllowDrop"
      @dragover="notAllowDrop"
      @paste="onPaste($event, item)"
      :contenteditable="edit && !item.disabled"
      v-else-if="
        item.type === 'text' &&
        item.textStyleList &&
        item.textStyleList.length > 0
      "
      :style="getStyle(item)"
      @input="onInput($event, item)"
      @compositionstart="onCompositionstart"
      @compositionend="onCompositionend($event, item)"
      @keyup="onKeyup($event, item)"
      @keydown="onKeydown($event, item)"
      @focus="onTextFocus($event, item)"
      @blur="onTextCssTextBlur($event, item)"
      ref="textParentRef"
    >
      <span
        v-for="(textItem, i) in item.textStyleList"
        class="text-bg-box selection-text"
        :alt="textItem.key"
        :class="{ 'js-selection-text': textItem.isSelectionNode }"
        :contenteditable="edit && !item.disabled"
        :key="`${i}_${textItem.key}_${textItem.text}`"
        :style="textStyle(textItem)"
        @click="onCssTextClick(textItem, item)"
        >{{ textItem.text
        }}<span
          class="text-bg"
          @click="onCssTextClick(textItem, item)"
          v-show="textItem.textBg.color"
          :style="textBgStyle(textItem)"
        ></span>
      </span>
    </div>
    <div
      class="option-text"
      :key="`${item.id}_${item.name}`"
      :contenteditable="edit && !item.disabled"
      v-else-if="item.type === 'text'"
      :style="getStyle(item)"
      ref="textParentRef"
      @paste="onPaste($event, item)"
      @drop="notAllowDrop"
      @dragover="notAllowDrop"
      @focus="onTextFocus($event, item)"
      @blur="onTextBlur($event, item)"
      @input="onInput($event, item)"
      @compositionstart="onCompositionstart"
      @compositionend="onCompositionend($event, item)"
      @keyup="onKeyup($event, item)"
      @keydown="onKeydown($event, item)"
    >
      <span
        class="default-text selection-text"
        :key="item.name"
        :data-key="item.key"
        @click="onCssTextClick(null, item)"
        v-text="item.name"
      >
      </span>
    </div>
  </div>
</template>
<script>
import {
  minus_plus,
  img_horizontal,
  img_vertical,
  img_two_direction
} from '../../../const.js'
import imgTemplate from '../../template/img-template/index'
import TUtil from '../TUtil'
import util from '@/util.js'
import uploadService from '@/request/service/fileupload-service'

export default {
  components: { imgTemplate },
  props: {
    parent: {
      type: Object,
      default () {
        return {}
      }
    },
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    edit: {
      type: Boolean,
      default: true
    },
    attrCover: {
      type: Boolean,
      default: false
    },
    dragMoving: {
      type: Boolean,
      default: true
    },
    rootScale: {
      type: Number,
      default: 1
    },
    layerResize: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      textEdit: false,
      originHeight: 0, // 获取焦点时文本的高度
      originWidth: 0,
      lastHeight: 0, // 文本变动时，累加高度值
      editorOption: {
        theme: 'bubble',
        modules: {
          toolbar: []
        }
      },
      errorItem: null // 文本过长提示
    }
  },
  computed: {
    selectedItem () {
      return this.$store.state.templateGroup.selectedItem
    },
    hasGroupMaterial () {
      let hasGroupMaterial = this.$store.state.group.groupArray.length > 0
      return hasGroupMaterial
    },
    editorSelectedImgIdx () {
      return this.$store.state.app.editorSelectedImgIdx
    },
    tableTipStyle () {
      let height = parseInt(32 / this.rootScale)
      let fontSize = parseInt(14 / this.rootScale)
      return `font-size:${fontSize}px;height:${height}px;line-height:${height}px;left: 0px;top:0px;`
    }
  },
  mounted () {},
  methods: {
    onPaste (event, item) {
      event.preventDefault()
      event.stopPropagation()
      if (event.clipboardData.types.indexOf('Files') > -1) {
        return
      }
      let pasteText = null
      if (event.clipboardData && event.clipboardData.getData) {
        pasteText = event.clipboardData.getData('text/plain')
      } else if (window.clipboardData && window.clipboardData.getData) {
        pasteText = window.clipboardData.getData('Text')
      }
      this.validateTextLen(event, item)
      if (document.queryCommandSupported('insertText')) {
        document.execCommand('insertText', false, pasteText)
      } else {
        document.execCommand('paste', false, pasteText)
      }
    },
    notAllowDrop (event) {
      event.preventDefault()
      return false
    },
    getStyleTextKey (item) {
      let arr = item.textStyleList.map(item => {
        return item.key
      })
      return `${item.id}_${arr.join()}`
    },
    getOptionClass (item) {
      let classArr = []
      if (item.type === 'img') {
        classArr.push('self-option-img')
      } else {
        classArr.push('self-option-text')
      }
      if (item.isPageBgImg && item.backgroundColor) {
        classArr.push('page-bg-color')
      } else if (item.isPageBgImg && !this.parent.isModuleGroup) {
        classArr.push('page-bg-img')
      }
      if (item.isBgImg || item.isPageBgImg) {
        classArr.push('item-bg-img')
      }
      let dct = item.direction || this.parent.direction
      if (dct) {
        classArr.push(dct)
      }
      if (item.missingFont) {
        classArr.push('c-missing-font')
      }
      if (item.isEditableTable) {
        classArr.push('table-hover')
      }
      if (this.errorItem === item) {
        classArr.push('more-text-error')
      }
      return classArr.join(' ')
    },
    getPageBgStyle (item) {
      return `width:${item.width}px;height:100%;background-color: ${item.backgroundColor};opacity: ${item.opacity}`
    },
    getStyle (item) {
      let baseStyle = `opacity: ${item.opacity};`
      if (item.type === 'text') {
        let fontSize = parseFloat(item.fontSize)
        let width = parseFloat(item.width)
        let letterSpacing = this.getLetterSpacing(item.letterSpacing)
        if (!item.alreadyFixed) {
          if (item.scale && item.scale.toString().indexOf(',') > -1) {
            let scaleW = parseFloat(item.scale.split(',')[0])
            fontSize = parseInt(scaleW * fontSize)
          }
          if (letterSpacing) {
            // 有字符间距时，宽度偏小
            width += letterSpacing + 5
          } else {
            width += Math.ceil(fontSize / 10)
          }
        }
        letterSpacing = letterSpacing ? `${letterSpacing}px` : 'normal'
        // if (item.originName === '内容1') {
        //   // console.log('text111', JSON.parse(JSON.stringify(item)))
        // }
        let lineHeight = this.getLineHeight(item)
        if (lineHeight) {
          lineHeight = `${lineHeight}px`
        } else {
          lineHeight = 'normal'
        }
        let textFontArray = [
          `transform-origin: ${item.transformOrigin}`,
          `padding:${item.padding || 0}px`,
          `backgroundColor:${item.backgroundColor || 'none'}`,
          `font-family:${item.fontFamily}`,
          `font-size: ${fontSize}px`,
          `color:${item.color}`,
          `letter-spacing: ${letterSpacing}`,
          `line-height: ${lineHeight}`,
          // `width: ${width}`,
          // `height: ${item.height}px`,
          `font-weight:${item.fontWeight}`,
          `text-shadow: ${item.textShadow}`,
          `font-style: ${item.fontStyle}`,
          `text-decoration:${item.textDecoration || 'none'}`
        ]
        //图片扩展
        let dc = item.direction || this.parent.direction
        let imgExtend = [img_horizontal, img_two_direction].indexOf(dc) > -1
        if (imgExtend) {
          textFontArray.push('width: auto')
        }
        let textFont = textFontArray.join(';')
        return baseStyle + textFont
      } else {
        let ra = null
        if (item.isCircle) {
          // 兼容老模板是数值字符类型
          ra = '50%'
        } else if (item.borderRadius) {
          ra = `${item.borderRadius}px`
        }
        let imgArray = [`border-radius:${ra}`]
        return baseStyle + imgArray.join(';')
      }
    },
    getLetterSpacing (letterSpacing) {
      if (!letterSpacing || letterSpacing === 'normal') {
        return null
      }
      if (isNaN(letterSpacing) && letterSpacing.indexOf('px') > -1) {
        letterSpacing = letterSpacing.split('px')[0]
      }
      return parseFloat(letterSpacing)
    },
    getLineHeight (item) {
      if (item.originName === '内容1') {
        console.log('内容1 lineHeight', item)
      }
      if (item.isMoreRow) {
        return item.lineHeight
      } else {
        // 单行文本使用height做lineHeight, 保证文本上下不会出现空白间距,
        // 如果文本换行则会设置originHeight属性，此处需要优先使用originHeight
        return item.originHeight || item.height
      }
    },
    textStyle (textItem) {
      let arr = []
      for (let key in textItem.style) {
        arr.push(`${key}: ${textItem.style[key]}`)
      }
      return arr.join(';')
    },
    textBgStyle (textItem) {
      let { bottom, height, color } = textItem.textBg
      if (color) {
        return `bottom:${bottom}px;height: ${height}px;background-color: ${color};`
      } else {
        return ''
      }
    },
    onImgClick (ev, item) {
      this.onItemClick(item, ev)
      if (item.disabled) {
        return
      }
      this.$emit('onMaterialImgClick', item, ev)
      this.$store.commit('templateGroup/set_selected_item', item)
    },
    onTextFocus (ev, item) {
      if (item.disabled || this.dragMoving) {
        return
      }
      if (!this.edit) {
        //面板页通过css设置text可编辑保证样式统一，但文件点击事件未触发 这里处理下
        this.onItemClick(item, ev)
      }
      this.validateTextLen(ev, item)
      this.originHeight = ev.target.offsetHeight
      this.originWidth = ev.target.offsetWidth // 用来记录获取焦点时，div宽度，方便后面计算失去焦点时的差值
      this.lastHeight = 0
      this.startHeight = ev.target.offsetHeight // 这个值后面会清空
      this.onMouseout(item)
      this.focusItem = item
      this.$emit('onTextFocus', item)
      this.$store.commit(
        'templateGroup/set_selected_dom',
        this.$refs.textParentRef
      )
      this.$store.commit('templateGroup/set_selected_item', item)
      if (item.textStyleList && item.textStyleList.length > 0) {
        this.initStyleTextEvent()
      }
    },
    onTextBlur (ev, item) {
      this.focusItem = null
      this.$emit('onTextBlur', ev, item)
      let domText = ev.target.innerText
      this.validateTextLen(ev, item)
      if (item.name !== domText) {
        this.$emit('addCache')
        item.name = domText
      }
      if (item.writingMode && item.writingMode !== 'initial') {
        let nWidth = ev.target.offsetWidth
        let minusW =
          item.writingMode === 'vertical-rl' ? nWidth - +item.width : 0
        item.width = nWidth
        item.left = +item.left - minusW
        item.right = +item.left + item.width
      }
      if (this.layerResize) {
        return
      }
      setTimeout(() => {
        this.compensatingErrorForCalcHeight(item)
      }, 200)
      this.autoExtend(this.parent, item, ev.target)
    },
    getTwoExtendImgItem (parent, textItem) {
      let tagName = textItem.tagName || ''
      let idx = parent.children.findIndex(item => {
        return (
          item.direction &&
          item.tagName === textItem.tagName &&
          textItem !== item
        )
      })
      if (idx > -1) {
        return parent.children[idx]
      }
      return null
    },
    getExtendImgItem (parent, textItem) {
      let tagName = textItem.tagName || ''
      let idx = (idx = parent.children.findIndex(item => {
        return item.direction && item.type === 'img'
      }))
      if (idx > -1) {
        return parent.children[idx]
      }
      return null
    },
    async autoExtendTwoDirection (parent, item, focusDom, cWidth, cHeight) {
      let imgItem = this.getTwoExtendImgItem(parent, item)
      if (imgItem === null) {
        return
      }
      console.info(cWidth, cHeight)
      let imgUrl = imgItem.url
      if (cWidth !== 0) {
        // 先横向扩展
        imgUrl = await util
          .extendImgForHorizontal(imgUrl, cWidth)
          .catch(() => {})
      }
      if (cHeight !== 0) {
        // 再垂直扩展
        imgUrl = await util
          .extendImgForVertical(imgUrl, cHeight)
          .catch(() => {})
      }
      if (imgUrl !== imgItem.url) {
        this.updateImgItem(imgItem, focusDom, cWidth, imgUrl)
      }
    },
    updateImgItem (imgItem, textItem, extendValue, imgUrl) {
      this.$emit('addCache')
      uploadService.uploadFileByBase64(imgUrl).then(({ url, properties }) => {
        let arr = properties.split('x')
        imgItem.width = arr[0]
        imgItem.height = arr[1]
        imgItem.url = url
        this.setItemForCenter(imgItem, textItem, extendValue)
      })
    },
    setItemForCenter (imgItem, textItem, val) {
      if (
        textItem.textAlign === 'center' &&
        imgItem.direction === img_horizontal
      ) {
        let halfVal = val / 2
        imgItem.left = +imgItem.left - halfVal
        textItem.left = +textItem.left - halfVal
        // 只扩展一层父级节点
        this.parent.left = +this.parent.left - halfVal
      }
      imgItem.bottom = +imgItem.height + +imgItem.top
      textItem.bottom = +textItem.height + +textItem.top
      imgItem.right = +imgItem.left + +imgItem.width
      textItem.right = +textItem.left + +textItem.width
      this.parent.right = +this.parent.right - +this.parent.width
    },
    autoExtend (parent, textItem, focusDom) {
      let directionDom = parent.direction || textItem.direction
      if (!directionDom) {
        return
      }
      let offsetWidth = focusDom.offsetWidth,
        offsetHeight = focusDom.offsetHeight
      let cWidth = offsetWidth - this.originWidth
      let cHeight = offsetHeight - this.originHeight
      parent.width = +parent.width + cWidth
      textItem.width = offsetWidth
      textItem.height = offsetHeight
      let twoExtend = textItem.direction || parent.direction
      if (twoExtend === img_two_direction) {
        this.autoExtendTwoDirection(parent, textItem, focusDom, cWidth, cHeight)
        return
      }
      let imgItem = this.getExtendImgItem(parent, textItem)
      if (imgItem === null) {
        return
      }
      let func = null,
        extendValue = null
      let dc = imgItem.direction
      if (dc === img_horizontal) {
        func = util.extendImgForHorizontal
        extendValue = cWidth
      } else if (dc === img_vertical) {
        func = util.extendImgForVertical
        extendValue = cHeight
      }
      if (extendValue === 0) {
        return
      }
      func &&
        func(imgItem.url, extendValue).then(base64 => {
          this.updateImgItem(imgItem, textItem, extendValue, base64)
        })
    },
    compensatingErrorForCalcHeight (item) {
      /*
       * 文本变动时，联动其它图层位置和高度，有时计算不准，失去焦点时对比高度，再重新补偿差值
       *
       * */
      if (!this.$refs.textParentRef) {
        return
      }
      let nowHeight = this.$refs.textParentRef.offsetHeight
      let minusVal = nowHeight - this.originHeight
      if (minusVal !== this.lastHeight) {
        let spaceHeight = minusVal - this.lastHeight
        let flag = spaceHeight > 0 ? minus_plus.plus : minus_plus.minus
        this.$emit('onKeydown', item, flag, Math.abs(spaceHeight))
      }
    },
    isEnter (str) {
      return str && str.trim() === '' && str.indexOf('\n') > -1
    },
    initStyleTextEvent () {
      document.addEventListener('selectionchange', this.onSelectionChange)
      document
        .querySelector('.tgi-aside')
        .addEventListener('click', this.updateStyleText)
      document
        .querySelector('.tgi-body-tools')
        .addEventListener('click', this.updateStyleText)
      document
        .querySelector('.teag-scale')
        .addEventListener('click', this.stopPropagationForUpdateStyleText)
      document
        .querySelector('.tgi-body-scale-layout')
        .addEventListener('click', this.updateStyleText)
    },
    removeStyleTextEvent () {
      document.removeEventListener('selectionchange', this.onSelectionChange)
      document
        .querySelector('.tgi-aside')
        .removeEventListener('click', this.updateStyleText)
      document
        .querySelector('.tgi-body-tools')
        .removeEventListener('click', this.updateStyleText)
      document
        .querySelector('.teag-scale')
        .removeEventListener('click', this.stopPropagationForUpdateStyleText)
      document
        .querySelector('.tgi-body-scale-layout')
        .removeEventListener('click', this.updateStyleText)
    },
    stopPropagationForUpdateStyleText (ev) {
      ev.stopPropagation()
    },
    /*
     * 样式文本失去焦点时，需要重新获取dom的样式，同步到vue属性中
     * 区分当前是失去焦点操作其它元素，还是去修改文本样式
     * 修改文本样式时，当前dom元素不做更新,textpanel中通过click.stop阻止选中状态消失
     * 切换到其它元素时，样式文本需要重新渲染,此时会触发焦点(selectionchange)事件
     */
    onSelectionChange (ev) {
      if (!this.edit) {
        return
      }
      let selection = window.getSelection()
      let noSelection = selection.type === 'None'
      let bfItem = this.$store.state.templateGroup.beforeSelectedItem
      let currentItem = this.selectedItem
      if (
        bfItem &&
        this.cssTextBlur &&
        (currentItem !== bfItem || noSelection)
      ) {
        // 更新dom数据
        this.updateBlurDom()
        this.removeStyleTextEvent()
        //dom更新完后，清空临时数据
        this.cssTextBlur = null
        this.$store.commit('templateGroup/set_before_focus_item', {
          dom: null,
          item: null
        })
      }
    },
    updateStyleText () {
      this.updateBlurDom()
    },
    onTextCssTextBlur (ev, item) {
      this.autoExtend(this.parent, item, ev.target)
      this.cssTextBlur = true
      this.validateTextLen(ev, item)
      this.$emit('onTextBlur', ev, item)
      this.$store.commit('templateGroup/set_before_focus_item', {
        dom: ev.target,
        item: item
      })
    },
    updateBlurDom () {
      let bfItem = this.$store.state.templateGroup.beforeSelectedItem
      let bfDom = this.$store.state.templateGroup.beforeSelectedTextDom
      if (bfDom && bfItem) {
        this.$emit('addCache')
        let textObj = TUtil.getTextStyle(bfDom)
        if (textObj.length === 0) {
          bfItem.name = ''
          bfItem.textStyleList = null
          return
        }
        if (bfItem.textStyleList) {
          bfItem.textStyleList = textObj
        } else {
          this.$set(bfItem, 'textStyleList', textObj)
        }
        bfItem.key = util.getUUID()
      }
    },
    deepChildNodes (nodes, list) {
      for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].children > 1) {
          this.deepChildNodes(nodes[i].children, list)
        } else {
          list.push(nodes[i])
        }
      }
    },
    isDelEvent (ev) {
      let keyCode = ev.keyCode
      let isDelKey = this.isDelKey(keyCode)
      let isCut = ev.ctrlKey && ev.key === 'x'
      return isDelKey || isCut
    },
    isEnterEvent (ev) {
      let isPaste = ev.ctrlKey && ev.key === 'v'
      let isEnterKey = ev.keyCode === 13
      return isEnterKey || isPaste
    },
    isDelKey (keyCode) {
      return [8, 46].indexOf(keyCode) > -1
    },
    disabledEditorOperation (item) {
      let notEdit = item.disabled
      return (
        notEdit ||
        !(
          (item.isLocalImg ||
            (item.isGroupMaterial && this.hasGroupMaterial)) &&
          this.edit
        )
      )
    },
    showImg (item) {
      return item.showImg || item.showImg === null || item.showImg === undefined
    },
    calcImgCoverStyle (item) {
      let { color, url } = item.coverObj
      if (!color && !url) {
        return ''
      }
      let bg = url
        ? `background-image: url(${url});background-size: 100% 100%;`
        : `background-color: ${color}`
      return `pointer-events: none;${bg};top: 0px;left:0px;width:${item.width}px;height: ${item.height}px;position: absolute;z-index: 1`
    },
    isGroupMaterial (item) {
      return item.isGroupMaterial && item.materialGroup
    },
    isFuncKey (ev) {
      let keyCode = ev.keyCode
      if (112 <= keyCode && keyCode <= 123) {
        return true
      }
      let funcKey = [
        'Control',
        'Shift',
        'CapsLock',
        'Tab',
        'Escape',
        'Alt',
        'ArrowLeft',
        'ArrowDown',
        'ArrowUp',
        'ArrowRight'
      ]
      if (funcKey.indexOf(ev.key) > -1) {
        return true
      }
      return false
    },
    onKeydown (ev, item) {
      this.onMouseout(item)
      if (!this.startHeight) {
        this.startHeight = ev.target.offsetHeight
      }
      if (ev.key === 'Enter') {
        let text = ev.currentTarget.textContent
        let lastEnter = text.substr(text.length - 1, text.length) === '\n'
        let isLastEnter = window.getSelection().focusOffset === text.length
        let enterStr = isLastEnter && !lastEnter ? '\n\n' : '\n' // 末尾需要两个换行符文本才会换行
        document.execCommand('insertHTML', false, enterStr)
        ev.preventDefault()
      }
      if (this.layerResize) {
        ev.stopPropagation()
      }
    },
    cutTextForMaxItem (ev, item) {
      let maxVal = +item.max
      if (maxVal === 0) {
        return
      }
      let text = ev.target.textContent
      if (text.length > maxVal) {
        ev.target.textContent = text.substring(0, maxVal)
      }
    },
    onKeyup (ev, item) {
      this.validateTextLen(ev, item)
      let text = ev.target.textContent
      if (!text) {
        ev.target.innerHTML =
          '<span  class="default-text selection-text"><br/></span>'
      }
      this.cutTextForMaxItem(ev, item)
    },
    onInput (ev, item) {
      if (!this.inputting) {
        this.calcHeight(ev, item, ev.target.offsetHeight - this.startHeight)
      }
    },
    calcHeight (ev, item, spaceHeight) {
      if (this.inputting) {
        return
      }
      if (this.timeoutVal) {
        window.clearTimeout(this.timeoutVal)
      }
      this.timeoutVal = setTimeout(() => {
        this.timeoutVal = null
        if (spaceHeight === 0) {
          return
        }
        this.startHeight = null
        this.lastHeight = +this.lastHeight + spaceHeight
        if (this.isEnterEvent(ev)) {
          this.$emit('onKeydown', item, minus_plus.plus, Math.abs(spaceHeight))
        } else if (this.isDelEvent(ev)) {
          this.$emit('onKeydown', item, minus_plus.minus, Math.abs(spaceHeight))
        } else {
          let value = spaceHeight > 0 ? minus_plus.plus : minus_plus.minus
          this.$emit('onKeydown', item, value, Math.abs(spaceHeight))
        }
      }, 200)
    },
    onCompositionstart () {
      this.inputting = true
    },
    onCompositionend (ev, item) {
      this.inputting = false
      this.calcHeight(ev, item, ev.target.offsetHeight - this.startHeight)
    },
    showImgEditor (item) {
      this.$refs.optionDomRef.click()
      this.$store.commit('templateGroup/set_selected_item', item)
      this.$store.commit('templateGroup/toggle_cropper_dialog', true)
      this.$emit('onCutImg', item)
    },
    onOpenGroupDialog (item) {
      this.$emit('onOpenGroupDialog', item)
      this.$store.commit('templateGroup/set_selected_item', item)
      this.$store.commit('group/toggle_dialog', true)
    },
    onItemClick (item, ev) {
      this.$emit('onItemClick', item, this.parent, ev)
      if (this.attrCover) {
        this.$store.commit('templateGroup/set_selected_item', item)
      }
    },
    onCssTextClick (cssItem, parent) {
      this.$store.commit('templateGroup/set_css_text', cssItem)
      let cssObj = cssItem
      if (cssItem) {
        cssObj = { ...cssItem.style, textBg: cssItem.textBg }
      } else {
        cssObj = TUtil.getDefaultCss(parent)
        cssObj['font-size'] += 'px'
      }
      cssObj.defaultTextBg = parent.defaultTextBg
      this.$emit('onCssTextClick', cssObj)
    },
    onMousehover (item) {
      if (this.dragMoving) {
        return
      }
      if (this.edit && this.focusItem !== item && item.type === 'text') {
        this.$emit('onTextHover', item)
      }
    },
    onMouseout (item) {
      if (this.dragMoving) {
        return
      }
      if (this.edit && item.type === 'text') {
        this.$emit('onTextHover', null)
      }
    },
    onHide (item) {
      item.hide = !item.hide
    },
    onTableClick (item) {
      this.$emit('onTableClick', item)
    },
    validateTextLen (ev, item) {
      this.errorItem = util.validateTextLen.call(this, ev, item.maxLength)
        ? item
        : null
      if (!this.errorItem && window.moreTextErrorMsg) {
        this.$message.closeAll()
      }
    }
  }
}
</script>
